export function FormField({ label, name, type="text", value, onChange, error }) {
  return (
    <label>
      {label}
      <input type={type} name={name} value={value} onChange={onChange} />
      {error && <span className="error-msg">{error}</span>}
    </label>
  );
}

export function FormSelect({ label, name, value, onChange, error, options }) {
  return (
    <label>
      {label}
      <select name={name} value={value} onChange={onChange}>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <span className="error-msg">{error}</span>}
    </label>
  );
}